<template>
    <div>
        <tracker-info v-if="showLabel" :label="trackerLabel" :position="trackerPosition"></tracker-info>
        <div class="absolute text-white py-[3px] text-xs whitespace-nowrap top-[50%] translate-y-[-50%] min-h-[22px] rounded"
             v-bind:class="{
            'hidden': periodEndedBeforeTimelineStart, 
            'before:content-[\'\'] before:top-0 before:absolute before:w-3 before:h-full before:z-20 before:left-0 before:bg-gradient-to-r before:from-white before:to-transparent': periodStartedBeforeTimelineStart,
            'rounded-r-none after:content-[\'\'] after:top-0 after:absolute after:w-3 after:h-full after:z-20 after:right-0 after:bg-gradient-to-l after:from-white after:to-transparent': periodStillActive
        }"
             :style="{left: left + '%', width:width + '%', background: background}"
             :title="value || label">
            <span class="overflow-hidden block text-xs px-2 m-auto">{{value}}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {useDetailStore} from "../../store";
    import TrackerInfo from "./tracker-info.vue";

    export default defineComponent({
        name: 'period',
        components: {TrackerInfo},
        props: {
            startDate: {
                type: Number,
                required: true
            },
            endDate: {
                type: Number,
                required: true
            },
            companyEndDate: {
                type: Number,
                required: true
            },
            value: String as  () => string | undefined,
            label: String,
            index: {
                type: Number,
                required: true
            },
            red: Boolean,
            timelineStart: {
                type: Number,
                required: true
            },
            timelineEnd: {
                type: Number,
                required: true
            },
            isMandateHolder: Boolean
        },
        data() {
            return {
                detailStore: useDetailStore()
            }
        },
        computed: {
            today(): number {
                return (new Date()).toHansDate();
            },
            trackerLabel(): string {
              return (this.isMandateHolder ? this.label : this.value) ?? this.label;
            },
            trackerPosition(): number {
                return this.detailStore.trackerPosition;  
            },
            showLabel(): boolean {
                const wrapperWidth = this.detailStore.wrapperWidth ?? 0;
                return this.trackerPosition > 0 && this.trackerPosition >= (this.left * wrapperWidth / 100) && this.trackerPosition <= (this.left + this.width) * wrapperWidth / 100; 
            },
            periodEndedBeforeTimelineStart(): boolean {
                return this.endDateConstrained < +this.timelineStart;
            },
            periodStartedBeforeTimelineStart(): boolean {
                return this.startDate < +this.timelineStart;
            },
            periodStillActive(): boolean {
                return (this.endDate === 0 || this.endDate >= this.companyEndDate) && this.companyEndDate >= this.today;
            },
            startDateConstrained(): number {
                return this.startDate < this.timelineStart ? this.timelineStart : this.startDate;
            },
            endDateConstrained(): number {
                return (this.endDate === 0 || this.endDate > this.companyEndDate) ? this.companyEndDate : this.endDate;
            },
            left(): number {
                return (Date.fromHansDate(this.startDateConstrained).getTime() - Date.fromHansDate(this.timelineStart).getTime()) /
                    (Date.fromHansDate(this.timelineEnd).getTime() - Date.fromHansDate(this.timelineStart).getTime()) * 100;
            },
            width(): number {
                return (Date.fromHansDate(this.endDateConstrained).getTime() - Date.fromHansDate(this.startDateConstrained).getTime()) /
                    (Date.fromHansDate(this.timelineEnd).getTime() - Date.fromHansDate(this.timelineStart).getTime()) * 100;
            },
            background(): string {
                const colors = [
                    '#0368FF',
                    '#7640EB',
                    '#0DC76E'
                ];

                return this.red 
                    ? '#C7492E' 
                    : colors[this.index % colors.length];
            }
        }
    });
</script>